const axios = require('axios');


export default {
    props: {
        sort: {
            type: String,
            default: 'desc'
        },
        initialPage: {
            type: String,
            default: '1'
        },
        limit: {
            type: String,
            default: '9'
        },
        except: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            entryType: '',
            page: this.initialPage,
            items: [],

            waypointStatus: true,
            loadedAll: false,

            intersectionOptions: {
                root: null,
                rootMargin: '0px 0px 0px 0px',
                threshold: [0, 1]
            }
        };
    },

    computed: {
        currentWaypointStatus() {
            return this.waypointStatus;
        }
    },

    methods: {
        onWaypoint ({ going, direction }) {
            if (this.loadedAll) {
                return;
            }

            if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_TOP) {

                let sortParam = this.sort == 'asc' ? 'date' : '-date';

                axios.get('/api/collections/' + this.entryType + '/entries?filter[id:isnt]=' + this.except + '&sort=' + sortParam + '&page=' + this.page + '&limit=' + this.limit)
                    .then(({data}) => {
                        this.items = this.items.concat(data.data)
                        this.page++;

                        if (data.data.length < this.limit) {
                            this.loadedAll = true;

                            // This throws a "e.unobserve is not a function" error. Using the 'loadedAll' flag approach instead.
                            // this.$removeObserver(document.querySelector('#waypoint'), this.intersectionOptions)
                        }
                    });
            }
        },

        truncate(str, max, suffix) {
            return str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;
        }

    }

};
